export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";